// Features/Render/mod.ts
async function renderSection({ section, at }) {
  const root = window.routes.rootUrl;
  const url = `${root}${at}?sections=${section}`;
  const html = await fetch(url).then((response) => response.json()).then((json) => json).then((data) => data[section]);
  return html;
}
export {
  renderSection
};
